import React from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../auth-container/reducer/authSlice.js';
import { useNotification } from '../../../hooks/useNotification.js';

const Header = ({ onSidebarToggle, onThemeToggle }) => {
  // Dynamic data for languages

  const dispatch = useDispatch();
  const { showSuccessNotification } = useNotification();

  const handleLogout = () => {
    dispatch(logout());
    showSuccessNotification('Logout successfully');
  };

  const languages = [
    {
      code: 'english',
      name: 'English',
      flagSrc: 'assets/images/flags/flag1.png',
    },
    { code: 'japan', name: 'Japan', flagSrc: 'assets/images/flags/flag2.png' },
    {
      code: 'france',
      name: 'France',
      flagSrc: 'assets/images/flags/flag3.png',
    },
    {
      code: 'germany',
      name: 'Germany',
      flagSrc: 'assets/images/flags/flag4.png',
    },
    {
      code: 'korea',
      name: 'South Korea',
      flagSrc: 'assets/images/flags/flag5.png',
    },
    {
      code: 'bangladesh',
      name: 'Bangladesh',
      flagSrc: 'assets/images/flags/flag6.png',
    },
    { code: 'india', name: 'India', flagSrc: 'assets/images/flags/flag7.png' },
    {
      code: 'canada',
      name: 'Canada',
      flagSrc: 'assets/images/flags/flag8.png',
    },
  ];

  // Dynamic data for notifications
  const notifications = [
    {
      title: 'Congratulations',
      message: 'Your profile has been Verified.',
      time: '23 Mins ago',
      icon: 'bitcoin-icons:verify-outline',
      imgSrc: '',
    },
    {
      title: 'Ronald Richards',
      message: 'You can stitch between artboards',
      time: '23 Mins ago',
      icon: '',
      imgSrc: 'assets/images/notification/profile-1.png',
    },
    {
      title: 'Arlene McCoy',
      message: 'Invite you to prototyping',
      time: '23 Mins ago',
      icon: '',
      imgSrc: '',
    },
    {
      title: 'Annette Black',
      message: 'Invite you to prototyping',
      time: '23 Mins ago',
      icon: '',
      imgSrc: 'assets/images/notification/profile-2.png',
    },
  ];

  return (
    <div className="navbar-header border-bottom">
      <div className="row align-items-center justify-content-between">
        <div className="col-auto">
          <div className="d-flex flex-wrap align-items-center gap-4">
            <button
              type="button"
              className="sidebar-toggle"
              onClick={onSidebarToggle}
            >
              <iconify-icon
                icon="line-md:menu-fold-left"
                width="24"
                height="24"
              ></iconify-icon>
            </button>
            <button
              type="button"
              className="sidebar-mobile-toggle"
              onClick={onSidebarToggle}
            >
              <iconify-icon
                icon="line-md:menu-fold-right"
                width="24"
                height="24"
              ></iconify-icon>
            </button>
            <div className="d-flex gap-2 align-items-center fw-medium text-black">
              <iconify-icon
                icon="material-symbols:admin-panel-settings-outline"
                width="24"
                height="24"
              ></iconify-icon>
              Admin Panel
            </div>
          </div>
        </div>
        {/* <div className="col-auto">
          <a href="">
            <img
              src="/assets/images/luxurylife.svg"
              className="img-fluid w-100-px"
              alt=""
            />
          </a>
        </div> */}
        <div className="col-auto">
          <div className="d-flex flex-wrap align-items-center gap-3">
            {/* <button
              type="button"
              data-theme-toggle
              onClick={onThemeToggle}
              className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
            /> */}
            {/* <div className="dropdown d-none d-sm-inline-block">
              <button
                className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                type="button"
                data-bs-toggle="dropdown"
              >
                <img
                  src="assets/images/lang-flag.png"
                  alt="image"
                  className="w-24 h-24 object-fit-cover rounded-circle"
                />
              </button>
              <div className="dropdown-menu to-top dropdown-menu-sm">
                <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                  <h6 className="text-lg text-primary-light fw-semibold mb-0">
                    Choose Your Language
                  </h6>
                </div>
                <div className="max-h-400-px overflow-y-auto scroll-sm pe-8">
                  {languages.map((lang) => (
                    <div
                      key={lang.code}
                      className="form-check style-check d-flex align-items-center justify-content-between mb-16"
                    >
                      <label
                        className="form-check-label line-height-1 fw-medium text-secondary-light"
                        htmlFor={lang.code}
                      >
                        <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                          <img
                            src={lang.flagSrc}
                            alt=""
                            className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                          />
                          <span className="text-md fw-semibold mb-0">
                            {lang.name}
                          </span>
                        </span>
                      </label>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="crypto"
                        id={lang.code}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div> */}

            {/* Notification dropdown */}
            {/* <div className="dropdown">
              <button
                className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                type="button"
                data-bs-toggle="dropdown"
              >
                <iconify-icon
                  icon="iconoir:bell"
                  className="text-primary-light text-xl"
                />
              </button>
              <div className="dropdown-menu to-top dropdown-menu-lg p-0">
                <div className="m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                  <h6 className="text-lg text-primary-light fw-semibold mb-0">
                    Notifications
                  </h6>
                  <span className="text-primary-600 fw-semibold text-lg w-40-px h-40-px rounded-circle bg-base d-flex justify-content-center align-items-center">
                    05
                  </span>
                </div>
                <div className="max-h-400-px overflow-y-auto scroll-sm pe-4">
                  {notifications.map((notification, index) => (
                    <a
                      key={index}
                      href="javascript:void(0)"
                      className={`px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between ${
                        index % 2 === 0 ? 'bg-neutral-50' : ''
                      }`}
                    >
                      <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                        {notification.icon ? (
                          <span className="w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                            <iconify-icon
                              icon={notification.icon}
                              className="icon text-xxl"
                            />
                          </span>
                        ) : (
                          <img
                            src={notification.imgSrc}
                            alt=""
                            className="w-44-px h-44-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                          />
                        )}
                        <div>
                          <h6 className="text-md fw-semibold mb-4">
                            {notification.title}
                          </h6>
                          <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                            {notification.message}
                          </p>
                        </div>
                      </div>
                      <span className="text-sm text-secondary-light flex-shrink-0">
                        {notification.time}
                      </span>
                    </a>
                  ))}
                </div>
                <div className="text-center py-12 px-16">
                  <a
                    href="javascript:void(0)"
                    className="text-primary-600 fw-semibold text-md"
                  >
                    See All Notification
                  </a>
                </div>
              </div>
            </div> */}

            {/* Profile dropdown */}
            <div className="dropdown">
              <button
                className="d-flex justify-content-center align-items-center rounded-circle"
                type="button"
                data-bs-toggle="dropdown"
              >
                <img
                  src="/assets/images/user.png"
                  alt="image"
                  className="w-40-px h-40-px object-fit-cover rounded-circle"
                />
              </button>
              <div className="dropdown-menu to-top dropdown-menu-sm">
                <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                  <div>
                    <h6 className="text-lg text-primary-light fw-semibold mb-2">
                      Jordan
                    </h6>
                    <span className="text-secondary-light fw-medium text-sm">
                      Admin
                    </span>
                  </div>
                  <button type="button" className="hover-text-danger">
                    {/* <iconify-icon
                      icon="radix-icons:cross-1"
                      className="icon text-xl"
                    /> */}
                  </button>
                </div>
                <ul className="to-top-list">
                  {/* <li>
                    <a
                      className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                      href="/"
                    >
                      <iconify-icon
                        icon="solar:user-linear"
                        className="icon text-xl"
                      />{' '}
                      My Profile
                    </a>
                  </li> */}
                  {/* <li>
                    <a
                      className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                      href="/"
                    >
                      <iconify-icon
                        icon="tabler:message-check"
                        className="icon text-xl"
                      />{' '}
                      Inbox
                    </a>
                  </li> */}
                  {/* <li>
                    <a
                      className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                      href="/"
                    >
                      <iconify-icon
                        icon="icon-park-outline:setting-two"
                        className="icon text-xl"
                      />{' '}
                      Setting
                    </a>
                  </li> */}
                  <li>
                    <a
                      onClick={handleLogout}
                      className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                      href="javascript:void(0)"
                    >
                      <iconify-icon
                        icon="lucide:power"
                        className="icon text-xl"
                      />{' '}
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
